import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Styles,
  Header, H1, H5, P,
  Row,
  Icon,
  Modal, ModalHeader, ModalBody
} from '@contently/toolkit';

const { colors } = Styles;

const ContentHeader = (props) => {
  const [modalOpen, setModalOpen] = useState();
  const { children } = props;

  return (
    <Fragment>
      <Header>
        <H1>
          {children}

          <Icon
            type="question-circle"
            color={colors.blue.primary}
            onClick={() => setModalOpen(!modalOpen)}
          />
        </H1>
      </Header>

      <Modal
        isOpen={modalOpen || false}
        onClose={() => setModalOpen(!modalOpen)}
      >

        <ModalHeader>Content request forms</ModalHeader>

        <ModalBody>
          <Row>
            <P>
              The form provides some standard fields that will automatically be added to each content request form.
            </P>
          </Row>

          <Row>
            <H5>Requestor info</H5>
            <ul>
              <li>First name</li>
              <li>Last name</li>
              <li>Email</li>
              <li>Department name</li>
            </ul>
          </Row>

          <Row>
            <H5>Content info</H5>
            <ul>
              <li>Request description</li>
              <li>Due date</li>
              <li>Single file upload</li>
            </ul>
          </Row>

          <Row>
            <H5>Optional fields</H5>
            <ul>
              <li>
                Audience: If this option is selected, the requestor will be provided with the opportunity to include a target audience for the content request. The audience options will be taken from the publication's content strategy.
              </li>
              <li>Pillar: If this option is selected, the requestor will be provided with the opportunity to include a pillar with the content request. The options will be taken from the publication's content strategy.</li>
            </ul>
          </Row>

          <Row>
            <P>
              In addition if you have a specific form that you want users to fill out when submitting a content request, please upload it to the form. Please use the instructions area to provide additional information to the user on how they should fill out the attached form.
            </P>
          </Row>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

ContentHeader.propTypes = {
  children: PropTypes.string.isRequired
};

export default ContentHeader;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_request_forms/header.jsx